import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';
import type { StockStatusStates } from './types';

export const StockStatus = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 1.5rem;
`;

export const IconAndText = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

interface TextProps {
  readonly toneDown?: boolean;
}

export const Text = styled.span<TextProps>`
  display: block;
  text-align: left;
  color: ${props =>
    !props.toneDown ? props.theme.colors.base500 : props.theme.colors.base600};
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const Tooltip = styled(TooltipComponent)`
  flex: 0 0 auto;
  *:first-child {
    &::first-letter {
      text-transform: capitalize;
    }
  }
`;

const getIconStyling = (
  theme: DefaultTheme,
  status?: StockStatusStates | null,
  toneDown?: boolean
) => {
  switch (status) {
    case 'in_stock_preorder':
    case 'incoming':
      return `background-color: ${
        theme.colors.base0
      }; box-shadow: inset 0 0 0 2px ${
        toneDown ? theme.colors.base300 : theme.colors.positive500
      }`;
    case 'in_stock':
      return toneDown
        ? `background-color: ${theme.colors.base200}`
        : `background-color: ${theme.colors.positive500}`;
    case 'not_in_stock':
      return toneDown
        ? `background-color: ${theme.colors.base200}`
        : `background-color: ${theme.colors.negative700}`;
    default:
      return toneDown
        ? `background-color: ${theme.colors.base200};`
        : `background-color: ${theme.colors.base500}`;
  }
};

interface IconProps {
  readonly status?: StockStatusStates | null;
  readonly toneDown?: boolean;
}

export const Icon = styled.span<IconProps>`
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin: 5px;
  ${props => getIconStyling(props.theme, props.status, props.toneDown)};
`;
